export function getAvatar(option) {
  return option.avatar || option.label?.avatar
}
